var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Observer from "../asset/observer";
import localizationLoader from "./localization.loader";
import * as Bluebird from "bluebird";
var Localize = /** @class */ (function (_super) {
    __extends(Localize, _super);
    function Localize(baseLanguage) {
        var _this = _super.call(this) || this;
        _this.dictionary = {};
        _this.dictionaryExtensions = [];
        _this.resourceFileLoaded = false;
        _this.language = window.navigator.language;
        _this.extend = function (dictionary) {
            _this.dictionaryExtensions.push(dictionary);
            _this.notify(_this.language, "localizeResourcesUpdates");
        };
        _this.loadOptionalLocaleExtension = function (location) {
            return _this.loadedPromise
                .then(function () { return localizationLoader.loadOptionalLocaleExtension(location); })
                .then(function (dictionary) { return _this.extend(dictionary); });
        };
        // loads the language resource file from the server
        _this.initLocalizedResources = function () {
            _this.resourceFileLoaded = false;
            localizationLoader.loadLanguage(_this.language).then(function (dict) {
                _this.dictionary = dict;
                _this.resourceFileLoaded = true;
                _this.notify(_this.language, "localizeResourcesUpdates");
                _this.onloadedCallback();
            });
        };
        _this.getLanguage = function () { return localizationLoader.loadedLanguage || _this.language; };
        _this.setLocales = function (_dictionary) {
            this.resourceFileLoaded = true;
            this.dictionary = _dictionary;
        };
        // allows setting of language on the fly
        _this.setLanguage = function (value) {
            if (this.language !== value) {
                this.language = value;
                this.initLocalizedResources();
            }
        };
        _this.parsePluralizationMatcher = function (pluralMatcher) {
            var pluralPart = pluralMatcher.split(".."), min, max;
            if (pluralPart.length === 1) {
                min = parseInt(pluralPart[0], 10);
                max = min;
            }
            else if (pluralPart.length === 2) {
                min = parseInt(pluralPart[0], 10);
                max = parseInt(pluralPart[1], 10);
            }
            if (isNaN(min) && isNaN(max)) {
                return false;
            }
            if (isNaN(min)) {
                min = -Infinity;
            }
            if (isNaN(max)) {
                max = Infinity;
            }
            return { min: min, max: max };
        };
        _this.matchesPluralization = function (pluralMatcher, count) {
            var parsed = this.parsePluralizationMatcher(pluralMatcher);
            return parsed && parsed.min <= count && parsed.max >= count;
        };
        _this.getDictionaryValue = function (value) {
            var keys = value.split(".");
            return [_this.dictionary].concat(_this.dictionaryExtensions).reverse().map(function (dictionary) {
                return keys
                    .reduce(function (prev, attr) { return prev[attr] ? prev[attr] : prev; }, dictionary);
            }).find(function (val) { return typeof val === "string"; });
        };
        // checks the dictionary for a localized resource string
        _this.getLocalizedString = function (value, replacements) {
            if (!_this.resourceFileLoaded) {
                return "";
            }
            var entry = _this.getDictionaryValue(value);
            if (typeof entry === "undefined" || typeof entry === "object") {
                return Localize.invalidTranslation(value);
            }
            if (!replacements) {
                return entry;
            }
            return Object.keys(replacements).reduce(function (prev, element) {
                return prev.replace(Localize.getFullReplacer(element), replacements[element]);
            }, entry);
        };
        if (baseLanguage) {
            _this.language = baseLanguage;
        }
        _this.loadedPromise = new Bluebird(function (resolve) {
            _this.onloadedCallback = resolve;
        });
        return _this;
    }
    Localize.invalidTranslation = function (value) {
        console.warn("Invalid Translation:" + value);
        return "Missing Translation: " + value;
    };
    Localize.getReplacementString = function (replacer) {
        return "{" + replacer + "}";
    };
    Localize.escapeRegExp = function (string) {
        return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    };
    Localize.regExpFromString = function (string, mode) {
        return new RegExp(Localize.escapeRegExp(string), mode);
    };
    Localize.getFullReplacer = function (replacer) {
        return Localize.regExpFromString(Localize.getReplacementString(replacer));
    };
    return Localize;
}(Observer));
export default Localize;



//////////////////
// WEBPACK FOOTER
// ./js/i18n/localize.ts
// module id = n8tu
// module chunks = 1 2 3 4